'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = wrapField;

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _tooltip = require('antd/lib/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapField(_ref, children) {
    var colon = _ref.colon,
        error = _ref.error,
        errorMessage = _ref.errorMessage,
        id = _ref.id,
        info = _ref.info,
        label = _ref.label,
        labelCol = _ref.labelCol,
        required = _ref.required,
        showInlineError = _ref.showInlineError,
        wrapperCol = _ref.wrapperCol;

    var labelNode = !!label && _react2.default.createElement(
        'span',
        null,
        label,
        !!info && _react2.default.createElement(
            'span',
            null,
            '\xA0',
            _react2.default.createElement(
                _tooltip2.default,
                { title: info },
                _react2.default.createElement(_icon2.default, { type: 'question-circle-o' })
            )
        )
    );

    return _react2.default.createElement(
        _form2.default.Item,
        {
            colon: colon,
            hasFeedback: true,
            help: showInlineError && error && errorMessage,
            htmlFor: id,
            label: labelNode,
            labelCol: labelCol,
            required: required,
            style: { marginBottom: '12px' },
            validateStatus: error ? 'error' : undefined,
            wrapperCol: wrapperCol
        },
        children
    );
}

_filterDOMProps2.default.register('colon', 'labelCol', 'wrapperCol');


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/wrapField.js
// module id = 40
// module chunks = 35783957827783 65974612472484